import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {MediaQueryService} from '@mydocma/core';
import {AddressTypeEnum, StructureAddress} from '@docma-mm-core/address/structure-address';
import {Structure} from '@docma-mm-core/structure/structure';
import {StructureAddressesService} from '../mm-structure-addresses.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {AppContainerService} from '@mydocma/app-container';

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-structure-addresses',
  templateUrl: './mm-structure-addresses.component.html',
  styleUrls: ['./mm-structure-addresses.component.scss']
})
export class MmStructureAddressesComponent implements OnChanges  {
  @Output() closeMenu = new EventEmitter<void>();
  // Keep output alias for backward compatibility with existing (isExpanded) bindings.
  @Output('isExpanded') isExpandedChange = new EventEmitter<boolean>();
  @Input() addresses: StructureAddress[];
  @Input() structure: Structure;
  @Input() dialogMode = false;

  isExpanded = false;
  hasAddresses = false;

  hasExtendedAddressData = false;
  addressTypes = AddressTypeEnum;

  setIsExpanded(value: boolean) {
    this.isExpanded = value;
    this.isExpandedChange.emit(this.isExpanded);
  }

  constructor(public readonly mediaQueryService: MediaQueryService,
              private readonly structureAddressesService: StructureAddressesService,
              public readonly appContainerService: AppContainerService) {

    this.structureAddressesService.hasAddresses$
      .pipe(untilDestroyed(this))
      .subscribe(hasAddresses => {
      this.hasAddresses = hasAddresses;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.addresses?.currentValue) {
      this.setIsExpanded(false);

      this.hasExtendedAddressData = this.addresses.some(x =>
        (x.Address.Fax ?? '') !== '' || (x.Address.Text1 ?? '') !== '' || (x.Address.Text2 ?? '') !== '' || x.Address.User?.Id != null);
    }
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
    this.isExpandedChange.emit(this.isExpanded);
  }

  closeByCode(): void {
    this.closeMenu.emit();
  }

}
